export const encounterRepresentation =
  'custom:(uuid,encounterDatetime,encounterType,location:(uuid,name),' +
  'patient:(uuid,display),encounterProviders:(uuid,provider:(uuid,name)),' +
  'obs:(uuid,obsDatetime,voided,groupMembers,formFieldNamespace,formFieldPath,concept:(uuid,name:(uuid,name)),value:(uuid,name:(uuid,name),' +
  'names:(uuid,conceptNameType,name))))';

export const personRepresntion =
  'custom:(display,uuid,personB:(age,gender,display,birthdate,uuid,addresses,names,attributes))';

export const FOLLOWUP_ENCOUNTER_TYPE_UUID = '136b2ded-22a3-4831-a39a-088d35a50ef5';

export const ictInformationFormUuid = 'c39ade81-678a-319c-93d7-f5b927ce7f27';
export const elicitedContactInfoFormUuid = '059cdca1-18bc-38c6-bd63-23661201ef3e';
export const ictOfferingFormUuid = '58211fe5-fbce-3530-b809-2597950fbb46';

export const ICT_GENERAL_ENCOUNTER_TYPE = 'bf097a70-4bb8-47dc-a127-1aacf86a86a0';
export const ICT_OFFERING_ENCOUNTER_TYPE = '23b08733-6d26-48b5-b135-dac294e25e1e';
export const ELICITED_CONTACT_INFO_ENCOUNTER_TYPE = '8a75cc8f-d700-4b09-8b96-97d519728d89';

export const MRN_NULL_WARNING =
  '* Patient needs to have a registered MRN, before this form can be filled! Please add an MRN on patient details.';
export const formWarning = (formName) =>
  `⚠️ Patient needs to have HIV Confirmed Date in ${formName} form before this form can be filled!`;
